module.exports = __webpack_public_path__ + "static/media/reclamation-icon.4b71ea94.svg";